import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

export const createUsageLogApi = async (
  userEmail,
  report_id,
  page_id,
  page_name
) => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/powerbi/usage-log`,
    method: "post",
    headers: headers,
    data: {
      user_email: userEmail,
      report_id: report_id,
      page_id: page_id,
      page_name: page_name,
    },
  };
  try {
    const response = await axios(options);
    return response;
  } catch (error) {
    console.log(error);
  }
};
